// extracted by mini-css-extract-plugin
module.exports = {"bodyDescription":"style_bodyDescription__3B3a-","bodyTitle":"style_bodyTitle__1ZggJ","bodyAuthor":"style_bodyAuthor__2ISrP"};